import { TranslateService } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";

import { FirewallSubscriptionDetails } from "../../../../../pages/subscription-detail/types";
import { InterconnectSummary } from "../../../interconnect-summary/interconnect-summary";
import { ConfigurationDetails } from "../../../tabbed-detail-container/components/configuration-details/configuration-details";
import { propertyKeysToRows } from "../../../tabbed-detail-container/tabbed-detail-container.helpers";

type FwL2Endpoint = FirewallSubscriptionDetails["l2Endpoints"][number];
type FwL3Endpoint = FirewallSubscriptionDetails["l3Endpoints"][number];
export type FwEndpoint = FwL2Endpoint | FwL3Endpoint;

function isL2Endpoint(e: FwEndpoint): e is FwL2Endpoint {
  return "ipv4PtpPrefixes" in e;
}

@Component({
  selector: "fw-endpoint-panel",
  templateUrl: "fw-endpoint-panel.html",
  host: { style: "display: contents" },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ConfigurationDetails, InterconnectSummary],
})
export class FwEndpointPanel {
  private translate = inject(TranslateService);

  endpoint = input.required<FwEndpoint>();

  protected service = computed(() => this.endpoint());

  protected configurationDetails = computed(() => {
    const e = this.endpoint();
    const rows =
      isL2Endpoint(e) ?
        propertyKeysToRows(
          this.translate,
          [
            {
              key: "ipv4PtpPrefixes",
              title: "ServiceElement.IPv4PointToPoint",
              display: "textbox",
              if: !!e.ipv4PtpPrefixes?.length,
            },
            {
              key: "ipv6PtpPrefixes",
              title: "ServiceElement.IPv6PointToPoint",
              display: "textbox",
              if: !!e.ipv6PtpPrefixes?.length,
            },
          ],
          e,
        )
      : [];
    return { title: this.translate.instant("ServiceElement.IPConfiguration"), rows };
  });

  protected hasConfigurationDetails = computed(() => this.configurationDetails().rows.length > 0);
}
